<template>
    <v-dialog v-model="shown" width="1100px" persistent>
        <v-card v-if="model">
            <v-card-title class="headline">{{model.title}}</v-card-title>
            <v-card-text>
                <div class="subtitle">Published on {{model.publishedOn | formatDate}}</div>
                <div v-html="formatContent(model.content)" />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="shown=false">Close</v-btn>
                <v-btn
                  color="primary"
                  @click="markAsSeen"
                  :loading="saving"
                  v-if="!model.seenOn"
                >Mark as Seen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';
import AnnouncementClient from '@/components/Announcements/AnnouncementClient.vue';
import FormValidation from '../FormValidation.vue';

export default {
    mixins: [AnnouncementClient, FormValidation],
    data() {
        return {
            model: null,
            shown: false,
            saving: false,
        };
    },
    computed: {
    },
    methods: {
        show(model) {
            this.shown = true;
            this.model = model;
            this.reset();
        },
        reset() {
            this.$validator.reset();
            this.saving = false;
        },
        formatContent(value) {
          if (typeof (value) === 'string') {
            return value.replace(/\n/g, '<br>');
          }

          return value;
        },
        async markAsSeen() {
            this.saving = true;

            if (this.model.seenOn) {
                return;
            }

            if (await this.markAnnouncementAsSeen(this.model.id)) {
                this.model.seenOn = Date.now();
                this.shown = false;
            }

            this.saving = false;
        }
    }
};
</script>
<style lang="scss">
.vh50 {
    height: 50vh;
    overflow-y: scroll;
}
.subtitle {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6); /* Adjust the color as needed */
  margin-bottom: 4px;
}
</style>
